import {ComponentProps} from 'react'
import CardGrid from "./CardGrid";

export const docProps : ComponentProps<typeof CardGrid> = {}

export default CardGrid;
